import { render, staticRenderFns } from "./TakePhoto.vue?vue&type=template&id=e2abddf6"
import script from "./TakePhoto.vue?vue&type=script&lang=js"
export * from "./TakePhoto.vue?vue&type=script&lang=js"
import style0 from "./TakePhoto.vue?vue&type=style&index=0&id=e2abddf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports